module.exports = "https://assets.calmac.co.uk/scripts/apps/overlays/1.10/img/routesRed.svg";